import { BaseService } from './base-service'
import { Observable } from 'rxjs'
import { RepaymentAPIConstant } from '@/api/constant/repayment'
import {
    RepaymentPageRequest,
    RepaymentPageRecord,
    PartRepaymentRequest,
    PartRepaymentData,
    LoanRepaymentRequest,
    RepaymentDetailRequest,
    RepaymentDetailResponse,
    RepaymentRequest,
    PenaltyFineRequest,
    PenaltyFinePageRecord,
    LoanRepaymentSubstractRequest,
    LoanRepaymentSubstractRecord,
    CalculationToFactTimeParams,
    CalculationToFactTimeRecord,
    CalculationExtendsRequest,
    CalculationExtendsResponse,
    UpdateRepaymentDetailRemarkRequest,
    VietRepaymentRequest,
    TallyBillApproveRecordRequest,
    TallyBillApproveRecord,
    PayRequestRecord,
    PayRequestRecordRequest
} from '@/api/model/repayment'
import { Page } from '@/api/model/base'

export class RepaymentService extends BaseService {
    protected repaymentConstant: RepaymentAPIConstant
    constructor() {
        super()
        this.repaymentConstant = new RepaymentAPIConstant()
    }

    repaymentPage(data: RepaymentPageRequest): Observable<Page<RepaymentPageRecord>> {
        return this.request(this.repaymentConstant.repaymentPage(data))
    }

    repaymentList(data: RepaymentRequest): Observable<RepaymentPageRecord[]> {
        return this.request(this.repaymentConstant.repaymentList(data))
    }

    partRepaymentLoadData(data: PartRepaymentRequest): Observable<PartRepaymentData> {
        return this.request(this.repaymentConstant.partRepaymentLoadData(data))
    }

    loanRepaymentToWriteOff(data: LoanRepaymentRequest): Observable<object> {
        return this.request(this.repaymentConstant.loanRepaymentToWriteOff(data))
    }

    loanRepaymentToPart(data: LoanRepaymentRequest): Observable<object> {
        return this.request(this.repaymentConstant.loanRepaymentToPart(data))
    }

    calcPartRepayment(data: LoanRepaymentRequest): Observable<PartRepaymentData> {
        return this.request(this.repaymentConstant.calcPartRepayment(data))
    }
    // 试算减少逾期天数
    calcDaysRepayment(data: LoanRepaymentRequest): Observable<PartRepaymentData> {
        return this.request(this.repaymentConstant.calcDaysRepayment(data))
    }
    queryRepaymentDetail(data: RepaymentDetailRequest): Observable<RepaymentDetailResponse> {
        return this.request(this.repaymentConstant.queryRepaymentDetail(data))
    }

    penaltyFinePage(data: PenaltyFineRequest): Observable<Page<PenaltyFinePageRecord>> {
        return this.request(this.repaymentConstant.penaltyFinePage(data))
    }
    //  查询催收核销记录
    tallyBillAproveRecordPage(data: TallyBillApproveRecordRequest): Observable<Page<TallyBillApproveRecord>> {
        return this.request(this.repaymentConstant.tallyBillAproveRecordPage(data))
    }
    // 取消核销
    cancelTallyBill(data: TallyBillApproveRecord): Observable<Object> {
        return this.request(this.repaymentConstant.cancelTallyBill(data))
    }

    // 查询三方支付记录列表
    payRequestRecordPage(data: PayRequestRecordRequest): Observable<Page<PayRequestRecord>> {
        return this.request(this.repaymentConstant.payRequestRecordPage(data))
    }

    // 上传stp支付成功记录文件
    uploadMutileFile(formData?: any): Observable<PayRequestRecord> {
        return this.request(this.repaymentConstant.uploadMutileFile(formData))
    }

    repaymentInfo(data: { lid: number; index?: number }): Observable<RepaymentPageRecord> {
        return this.request(this.repaymentConstant.repaymentInfo(data))
    }

    pauseCollection(data: { mid: number; cameraId: number, remark: string }): Observable<object> {
        return this.request(this.repaymentConstant.pauseCollection(data))
    }

    resumeCollection(data: { mid: number; cameraId: number, remark: string }): Observable<object> {
        return this.request(this.repaymentConstant.resumeCollection(data))
    }

    submitRepaymentSubstract(data: LoanRepaymentSubstractRequest): Observable<object> {
        return this.request(this.repaymentConstant.submitRepaymentSubstract(data))
    }

    queryRepaymentSubstract(data: { lid: number; index?: number }): Observable<LoanRepaymentSubstractRecord[]> {
        return this.request(this.repaymentConstant.queryRepaymentSubstract(data))
    }

    calculationToFactTime(data: CalculationToFactTimeParams): Observable<CalculationToFactTimeRecord> {
        return this.request(this.repaymentConstant.calculationToFactTime(data))
    }

    loanRepaymentToFactTime(data: LoanRepaymentRequest): Observable<string> {
        return this.request(this.repaymentConstant.loanRepaymentToFactTime(data))
    }

    vietRepayment(data: VietRepaymentRequest): Observable<string> {
        return this.request(this.repaymentConstant.vietRepayment(data))
    }

    calculationExtends(data: CalculationExtendsRequest): Observable<CalculationExtendsResponse> {
        return this.request(this.repaymentConstant.calculationExtends(data))
    }

    repaymentExtends(data: CalculationExtendsRequest): Observable<Boolean> {
        return this.request(this.repaymentConstant.repaymentExtends(data))
    }

    updateRepaymentDetailRemark(data: UpdateRepaymentDetailRemarkRequest): Observable<object> {
        return this.request(this.repaymentConstant.updateRepaymentDetailRemark(data))
    }
}
